import { lazy } from 'react';

// project imports
import MainLayout from 'jsx/layout/MainLayout';
import Loadable from 'jsx/components/utilities/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// employee routes
const Dashboard = Loadable(lazy(() => import('jsx/views/Dashboard2')));
const Dashboard2 = Loadable(lazy(() => import('jsx/views/admin/Dashboard/DashBoard2')));
const Dashboard3 = Loadable(lazy(() => import('jsx/views/admin/Dashboard/DashBoard3')));
const Organization = Loadable(lazy(() => import('jsx/views/CA/Organization')));
const ChartedAccount = Loadable(lazy(() => import('jsx/views/admin/ChartedAcount')));
const EmployeeList = Loadable(lazy(() => import('jsx/views/admin/Organization/EmployeeList')));
const AccountProfile = Loadable(lazy(() => import('jsx/views/admin/AdminUsers/AccountProfile')));
const SupportTickets = Loadable(lazy(() => import('jsx/views/CA/support')));
const DemoRequests = Loadable(lazy(() => import('jsx/views/admin/DemoRequests')));
const CompanySettings = Loadable(lazy(() => import('jsx/views/CA/CompanySettings')));
const EmployeeDetails = Loadable(lazy(() => import('jsx/views/admin/Organization/employee-details')));
const ChangePassword = Loadable(lazy(() => import('jsx/pages/authentication/auth-forms/ChangePassword')));


const CaRoutes = {
    path: '/ca',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'organization', element: <Organization /> },
        { path: 'organization/create', element: <CompanySettings /> },
        { path: 'organization/:company_uuid/edit', element: <CompanySettings /> },
        { path: 'organization/:company_uuid/employee', element: <EmployeeList /> },
        { path: 'organization/:company_uuid/employee/:employee_uuid', element: <EmployeeDetails /> },
        { path: 'account/profile', element: <AccountProfile /> },
        { path: 'support-tickets', element: <SupportTickets /> },
        { path: 'change-password', element: <ChangePassword /> }
        // { path: 'demo-requests', element: <DemoRequests /> },
    ]
};

export default CaRoutes;
